import { DropResult } from 'react-beautiful-dnd';
import { returnSortOrder } from 'utils/sort-order/returnSortOrder';
import { throwErrorIfFalsy, throwErrorIfNegative } from 'utils/error/throwErrorr';

export const handleSortOrderAsc = (dropResult: DropResult, list: any) => {
  // 이상한 곳에 놓았을 경우
  if (!dropResult.destination) return;

  const destinationIndex = dropResult.destination?.index;
  const sourceIndex = dropResult.source.index;

  // sortOrder 증가
  if (sourceIndex < destinationIndex) {
    return increaseOrder(dropResult, list);
  }

  // sortOrder 감소
  return decreaseOrder(dropResult, list);
};

const increaseOrder = (dropResult: DropResult, list: any) => {
  if (!dropResult.destination) return;

  //  아이템을 맨 마지막으로 옮겼을 경우
  if (!list[dropResult.destination.index + 1]) {
    return list[dropResult.destination.index].sortOrder + 1000;
  }

  const prevSortOrder = list[dropResult.destination.index + 1].sortOrder;
  const nextSortOrder = list[dropResult.destination.index].sortOrder;

  const sortOrder = returnSortOrder(prevSortOrder, nextSortOrder);
  return sortOrder;
};

const decreaseOrder = (dropResult: DropResult, list: any) => {
  if (!dropResult.destination) return;

  // 아이템을 맨 처음으로 옮겼을 경우
  if (!list[dropResult.destination.index - 1]) {
    const sortOrder = list[dropResult.destination.index].sortOrder / 2;
    throwErrorIfFalsy(sortOrder);
    throwErrorIfNegative(sortOrder);
    return sortOrder;
  }

  const prevSortOrder = list[dropResult.destination.index].sortOrder;
  const nextSortOrder = list[dropResult.destination.index - 1].sortOrder;

  const sortOrder = returnSortOrder(prevSortOrder, nextSortOrder);
  return sortOrder;
};
